import { Stack, TextField } from "@mui/material";
import type { FC, KeyboardEventHandler } from "react";
import { useCallback } from "react";
import { useCustomerNoteTypes } from "../../admin/dictionaries/useCustomerNoteTypes";
import { Select } from "../../components/select/Select";

export interface CustomerNoteFieldsProps {
  readonly disabled?: boolean;
  readonly noteType: string | null;
  readonly text: string;
  readonly onNoteTypeChange: (noteType: string | null) => void;
  readonly onTextChange: (text: string) => void;
  readonly onSubmit?: () => void | Promise<void>;
}

export const CustomerNoteFields: FC<CustomerNoteFieldsProps> = ({
  disabled,
  noteType,
  text,
  onNoteTypeChange,
  onTextChange,
  onSubmit,
}) => {
  const { noteTypes } = useCustomerNoteTypes();

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = useCallback(
    async (e) => {
      if (e.key !== "Enter") {
        return;
      }
      if (!onSubmit) {
        return;
      }
      e.preventDefault();
      await onSubmit();
    },
    [onSubmit],
  );

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "space-between",
      }}
    >
      <Select
        label="Typ notatki"
        style={{ flexGrow: 1 }}
        value={noteType ?? ""}
        values={[{ label: " ", value: "" }, ...noteTypes.map((t) => ({ label: t.name, value: t.name }))]}
        onSelect={(v) => onNoteTypeChange(v === "" ? null : v)}
      />
      <TextField
        label="Nowa notatka"
        value={text}
        onKeyDown={onSubmit ? handleKeyDown : undefined}
        onChange={(e) => onTextChange(e.target.value)}
        style={{ flexGrow: 4 }}
        disabled={disabled}
      />
    </Stack>
  );
};
